import { LT_URL } from 'bl/loggers.bl';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromPathToSegments from 'utils/converters/path/fromPathToSegments.util';
import fromSegmentsToPath from 'utils/converters/path/fromSegmentsToPath.util';
import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger(['MODIFY', LT_URL]);

const prependQuestionMark = (when, string) => {
  try {
    if ('never' === when || false === when) return string;
    if ('always' === when || true === when) return `?${string}`;

    if (void 1 !== when && 'as-needed' !== when) L.warn('prependQuestionMark()', 'Invalid when:', when);

    return string ? `?${string}` : string;
  } catch (e) {
    L.warn('prependQuestionMark()', e, 'for when:', when, 'and string:', string);
  }
};

export const modifySearchParams = (options) => {
  try {
    const { queryString, searchParams, addParams } = options ?? {};

    const params = new URLSearchParams(fromAnyToString(queryString) || searchParams);
    const entries = Array.isArray(addParams) ? addParams : Object.entries(addParams ?? {});

    for (const [key, val] of entries) {
      if (Array.isArray(val)) {
        for (const v of val) params.append(key, v);
      } else {
        // noinspection JSCheckFunctionSignatures
        params.append(key, val);
      }
    }

    const result = prependQuestionMark(options?.prependMark, params.toString());

    L.debug('modifySearchParams()', options, '->', params, '->', result);

    return result;
  } catch (e) {
    L.warn('modifySearchParams()', options, '->', e);
    return '';
  }
};

export const modifyUrl = (options) => {
  try {
    const u = new URL(options?.url);
    const { search, host, protocol, pathname, hash } = u;

    const params = modifySearchParams({ searchParams: search, addParams: options?.addParams, prependMark: 'never' });

    // noinspection SpellCheckingInspection
    const prot = options?.delProtocol ? '' : `${protocol}//`;
    const path = options?.delSlash && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

    const result = params || `${hash}` ? `${prot}${host}${path}?${params}${hash}` : `${prot}${host}${path}`;

    L.debug('modifyUrl()', options, '->', { host, path, hash, search, params }, '->', result);

    return result;
  } catch (e) {
    L.warn('modifyUrl()', options, '->', e);
    return '';
  }
};

export const transformPath = (fn, path) => {
  if (isNotFn(fn)) return '';

  const segments = fromPathToSegments(path);
  const modified = fn(segments);
  return fromSegmentsToPath(modified);
};
